function intro()
{
    const musicPlayer = document.querySelector('.audio-music-player');
    const musicAudio = document.getElementById('music-audio');
    const playBtn = document.getElementById('music-btn');
    const introOverlay = document.querySelector('.music-intro-overlay');
    const acceptMusicBtn = document.getElementById('accept-music');
    const rejectMusicBtn = document.getElementById('reject-music');
    const header = document.querySelector('header.banner');

    if (introOverlay) {
        introOverlay.style.display = "block";

        document.body.classList.add('no-scroll');

        if (header) {
            header.classList.add('z-low');
        }

        acceptMusicBtn.addEventListener('click', function () {
            introOverlay.style.display = 'none';
            musicAudio.play();
            playBtn.classList.remove('is-paused');
            document.body.classList.remove('no-scroll');

            if (header) {
                header.classList.remove('z-low');
            }
        });

        rejectMusicBtn.addEventListener('click', function () {
            introOverlay.style.display = 'none';
            musicAudio.pause();
            playBtn.classList.add('is-paused');
            document.body.classList.remove('no-scroll');

            if (header) {
                header.classList.remove('z-low');
            }
        });
    }




}

export { intro };
